<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="card card-primary" v-if="showTickList">
                <div class="card-header">
                    {{trans('projects.cards.header.budget_list')}}
                </div>
                <div class="card-body">
                    <div v-for="(perioditems, index) in tickListSorted" class="clearfix">
                        <table v-bind:index="index"
                               class="table table-sm table-responsive table-bordered table-period-item">
                            <thead>
                            <tr>
                                <th>&nbsp;<span class="btn btn-sm btn-outline-danger delete-period-item"
                                                @click="deleteAllPeriod(perioditems)">
                                Delete all period</span></th>
                                <th></th>
                                <th v-for="campaignType in campaignTypes">
                                    {{campaignType.name}}
                                    <span v-if="getBudgetCampaignItem(perioditems, campaignType)"
                                          class="btn btn-sm edit-period-item"
                                          @click="startEdit(getBudgetCampaignItem(perioditems, campaignType))">
                                        <span class="fa fa-edit"></span>
                                    </span>
                                    <span class="btn btn-sm btn-outline-danger delete-period-item"
                                          @click="deletePeriodItem(perioditems, campaignType)">x</span>
                                </th>
                                <th><strong>Sum</strong></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{{ printPeriod(perioditems) }}</td>
                                <td>Period Budget</td>
                                <td v-for="campaignType in campaignTypes"
                                    v-html="printCampaignBudget(perioditems, campaignType)">
                                </td>
                                <td><strong v-html="printSum(perioditems, 'budget')"></strong></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Total Budget</td>
                                <td v-for="campaignType in campaignTypes"
                                    v-html="getSumBudgetToActual(perioditems, campaignType)">
                                </td>
                                <td><strong v-html="printSum(perioditems, 'full_budget')"></strong></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Spent Budget</td>
                                <td v-for="campaignType in campaignTypes"
                                    v-html="printSpentBudget(perioditems, campaignType)">
                                </td>
                                <td><strong v-html="printSum(perioditems, 'spent_budget')"></strong></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Remaining Budget</td>
                                <td v-for="campaignType in campaignTypes"
                                    v-html="getRemainingBudget(perioditems, campaignType)">
                                </td>
                                <td><strong v-html="printSum(perioditems, 'remaining_budget')"></strong></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Budget to invoice</td>
                                <td v-for="campaignType in campaignTypes"
                                    v-html="getBudgetOnInvoice(perioditems, campaignType)">
                                </td>
                                <td><strong v-html="printSum(perioditems, 'budget_to_invoice')"></strong></td>
                            </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-primary" @click="changeShowed(index)">
                            <span class="show-text">Show {{ printPeriod(perioditems) }}</span><span class="hide-text">&nbsp;<&nbsp;</span>
                        </button>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">
                            <hr>
                            <br>
                            <div v-if="errorMessages.length > 0" class="alert alert-danger alert-dismissable">
                                <button type="button" class="close" data-dismiss="alert"
                                        aria-hidden="true">&times;
                                </button>
                                <strong>Error:</strong> <span v-for="errorMessage in errorMessages">{{ errorMessage }}
                                &nbsp;</span>
                            </div>
                            <div v-if="edit" class="form-row">
                                <div class="col">
                                    <label for="period">Period</label>
                                    <input v-model="editTickItem.period" type="text" class="form-control"
                                           name="period" id="period"
                                           :placeholder="nowPivotMonth">
                                </div>
                                <div class="col">
                                    <label for="budget">Period Budget</label>
                                    <input v-model="editTickItem.budget" type="text" class="form-control"
                                           name="budget" id="period_budget"
                                           placeholder="Budget">
                                </div>
                                <div class="col">
                                    <label for="spent_budget">Spent Budget</label>
                                    <input v-model="editTickItem.spent_budget" type="text" class="form-control"
                                           name="spent_budget" id="spent_budget"
                                           placeholder="Spent budget">
                                </div>
                                <div class="col">
                                    <label for="budget_to_invoice">Budget to invoice</label>
                                    <input v-model="editTickItem.budget_to_invoice" type="text" class="form-control"
                                           name="budget_to_invoice" id="budget_to_invoice"
                                           placeholder="Budget to invoice">
                                </div>
                                <div class="col">
                                    <label for="budget_campaign_id">Campaign</label>
                                    <select v-model="editTickItem.budget_campaign_id" name="budget_campaign_id"
                                            id="budget_campaign_id"
                                            class="form-control">
                                        <option v-for="campaign_type in budget_campaign_types_local"
                                                v-bind:value="campaign_type.id">{{campaign_type.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-sm-2">
                                    <label class="control-label" style="width: 100%; display: block">&nbsp;</label>
                                    <button class="btn btn-primary" @click="editTickListItem">Edit</button>
                                    <button class="btn btn-secondary" @click="edit = false">Cancel</button>
                                </div>
                            </div>
                            <div v-else class="form-row">
                                <div class="col">
                                    <label for="period">Period</label>
                                    <input v-model="newTickItem.period" type="text" class="form-control"
                                           name="period" id="period"
                                           :placeholder="nowPivotMonth">
                                </div>
                                <div class="col">
                                    <label for="budget">Period Budget</label>
                                    <input v-model.number="newTickItem.budget" type="text" class="form-control"
                                           name="budget" id="budget"
                                           placeholder="Budget">
                                </div>
                                <div class="col">
                                    <label for="budget_campaign_id">Campaign</label>

                                    <select v-model="newTickItem.budget_campaign_id" name="budget_campaign_id"
                                            id="budget_campaign_id"
                                            class="form-control">
                                        <option v-for="campaign_type in budget_campaign_types_local"
                                                v-bind:value="campaign_type.id">{{campaign_type.name}}
                                        </option>
                                        <option value="-1">Create new ..</option>
                                    </select>
                                </div>
                                <div class="col-sm-2">
                                    <label class="control-label" style="width: 100%; display: block">&nbsp;</label>
                                    <button class="btn btn-primary" @click="createTickListItem">Create</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="card card-no-bg">
                <button v-if="tickList.length" class="btn btn-primary" @click="makeShowTickList">Show Budget List
                </button>
                <button v-else class="btn btn-primary" @click="makeShowTickList">Create Budget List</button>
            </div>
        </div>
    </div>
</template>

<script>

    let moment = require('moment');
    import _ from 'lodash';

    export default {
        props: {
            budget_campaign_types: Array,
            project: Object,
        },
        data: function () {
            return {
                edit: false,
                tickList: [],
                newTickItem: {},
                editTickItem: {},
                showTickList: false,
                errorMessages: [],
                budget_campaign_types_local: this.budget_campaign_types,
                deletePeriodItems: [],
                deleteCampaignType: {},
                nowPivotMonth: moment().format('MM/YYYY')
            };
        },
        computed: {
            tickListSorted: function () {
                return _.sortBy(this.tickList, function (periodItems) {
                    return moment(periodItems[0].period, 'MM/YYYY');

                    // if (moment(periodItems1[0].period, 'MM/YYYY') > moment(periodItems2[0].period, 'MM/YYYY')) {
                    //     return 1;
                    // }
                    // return -1;
                });
            },
            campaignTypes: function () {

                var types = [];
                this.tickList.forEach(function (tickListItem) {
//                    console.log(tickListItem);
                    tickListItem.forEach(function (item) {
                        if (types.filter(function (value) {
                                if (item.budget_campaign_type) {
                                    return value.id === item.budget_campaign_type.id;
                                }

                            }).length == 0
                        ) {
                            if (item.budget_campaign_type) {
                                types.push(item.budget_campaign_type);
                            }

                        }

                    });
                });
                return types;
            }
        },
        created: function () {
            this.newItemToBase();
            this.fetchTickList();
            this.listen();
        },
        watch: {
            'newTickItem.budget_campaign_id': function (item) {
                if (item == -1 || item == "-1") {
                    VisiModal.showModal(laroute.route('settings.budget_campaign_types.create', {project_id: this.project.id}));
                }
            }
        },
        methods: {
            trans: function (path) {
                return Lang.trans(path);
            },
            changeShowed: function (index) {
                var el = jQuery("table[index=" + index + "]");
                if (el.hasClass('active')) {
                    el.parent().css('height', '');
                } else {
                    el.parent().css('height', (el.height() + 2));
                }

                el.toggleClass('active').toggle();
            },
            listen: function () {
                var vm = this;
                // var channel = pusher
                //     .subscribe('budget-campaign-types-{{$project->id}}');

                Echo.channel('budget-campaign-types-' + this.project.id)
                    .listen('BudgetCampaignType\\Create', (event) => {
                        vm.budget_campaign_types_local.push(event.budget_campaign_type);
                        if (vm.edit) {
                            vm.editTickItem.budget_campaign_id = event.budget_campaign_type.id;
                        } else {
                            vm.newTickItem.budget_campaign_id = event.budget_campaign_type.id;
                        }
                    });

                // channel.bind('create-item', function (data) {
                //     vm.budget_campaign_types_local.push(data);
                //     if (vm.edit) {
                //         vm.editTickItem.budget_campaign_id = data.id;
                //     } else {
                //         vm.newTickItem.budget_campaign_id = data.id;
                //     }
                //
                // });
            },
            createNewCampaignType: function (el) {
//                console.log(el);
//                changeModal(el);
            },
            printSum(periodItems, field){
                if(field === 'remaining_budget'){
                    return Render.renderNumber(_.sumBy(periodItems, function(item){
                        return item.full_budget - item.spent_budget;
                    }))
                }
                return Render.renderNumber(_.sumBy(periodItems, field));
            },
            getSumBudgetToActual: function (periodItems, campaignType) {
                var item = this.getBudgetCampaignItem(periodItems, campaignType);
                if (item) {
                    return Render.renderNumber(item.full_budget);
                } else {
                    return Render.renderNumber(0);
                }
            },
            getBudgetOnInvoice: function (periodItems, campaignType) {
                var item = this.getBudgetCampaignItem(periodItems, campaignType);
                if (item) {
                    return Render.renderNumber(item.budget_to_invoice);
                } else {
                    return Render.renderNumber(0);
                }
            },
            getRemainingBudget: function (periodItems, campaignType) {
                var item = this.getBudgetCampaignItem(periodItems, campaignType);
                if (item) {
                    return Render.renderNumber(item.full_budget - item.spent_budget);
                } else {
                    return Render.renderNumber(0);
                }

            },
            startEdit: function (periodItem) {
                this.edit = true;
                this.editTickItem = Object.assign({}, periodItem);
//                        this.editTickItem = periodItem;
            },
            getBudgetCampaignItem: function (periodItems, campaignType) {
                var item = null;

                periodItems.filter(function (periodItem) {
                    if (campaignType.id == periodItem.budget_campaign_id) {
                        item = periodItem;
                    }
                });
                return item;
            },
            deleteAllPeriod: function (periodItems) {
                // var resource = this.$resource('/visi/api/budget-campaigns{/id}');
                var vm = this;

                var r = confirm("Are you sure to delete this period ?");
                if (r == true) {
                    let vm = this;
                    periodItems.forEach(function (periodItem) {
                        axios.delete(laroute.route('json.budget_campaigns', {budget_campaign: periodItem.id}))
                            .then(response => {
                                if (response.data.success) {
                                    vm.fetchTickList();
                                } else {
                                    vm.throwError('Error :(');
                                }
                            })
                            .catch(error => {
                                console.log(error);
                                vm.throwError(_.values(error.response.data.errors));
                                // vm.throwError(error.data.errors.join(', '));
                            });

                        // resource.delete({id: periodItem.id}).then(function (response) {
                        //     response = response.body;
                        //     if (response.success) {
                        //         this.fetchTickList();
                        //     } else {
                        //         this.throwError(response.error);
                        //     }
                        // });
                    });
                }

            },
            deletePeriodItem: function (periodItems, campaignType) {
                // var resource = this.$resource('/visi/api/budget-campaigns{/id}');
                var vm = this;

                var r = confirm("Are you sure to delete this item ?");
                if (r == true) {
                    periodItems.filter(function (periodItem) {
                        if (campaignType.id == periodItem.budget_campaign_id) {

                            axios.delete(laroute.route('json.budget_campaigns', {budget_campaign: periodItem.id}))
                                .then(response => {
                                    if (response.data.success) {
                                        vm.fetchTickList();
                                    } else {
                                        vm.throwError('Error :(');
                                    }
                                })
                                .catch(error => {
                                    console.log(error);
                                    vm.throwError(_.values(error.response.data.errors));

                                });

                            // resource.delete({id: periodItem.id}).then(function (response) {
                            //     response = response.body;
                            //     if (response.success) {
                            //         this.fetchTickList();
                            //     } else {
                            //         this.throwError(response.error);
                            //     }
                            // });
                        }
                    });
                }

            },
            printFullBudget: function (periodItems, campaignType) {
                return 0;
            },
            printSpentBudget: function (periodItems, campaignType) {
                var item = this.getBudgetCampaignItem(periodItems, campaignType);
                if (item) {
                    return Render.renderNumber(item.spent_budget);
                }
                return Render.renderNumber(0);
            },
            printCampaignBudget: function (periodItems, campaignType) {
                var item = this.getBudgetCampaignItem(periodItems, campaignType);
                if (item) {
                    return Render.renderNumber(item.budget);
                }
                return Render.renderNumber(0);
            },
            printPeriod: function (periodItems) {
//                        return moment(periodItems[0].period, 'YYYY-MM-DD').format('MM/YYYY');
                return periodItems[0].period;
            },
            newItemToBase: function () {
                this.newTickItem = Object.assign({}, this.newTickItem,
                    {
                        project_id: this.project.id,
                        period: this.nowPivotMonth,
                        budget: "",
                        spent_budget: "",
                        budget_campaign_id: ""
                    });
            },
            throwError: function (error) {
                if (Array.isArray(error)) {
                    this.errorMessages = error;
                } else {
                    this.errorMessages = [error];
                }
            },
            disableErrors: function () {
                this.errorMessages = [];
            },
            createTickListItem: function () {
                // var resource = this.$resource('/visi/api/budget-campaigns{/id}');
                let vm = this;
                this.disableErrors();

                axios.post(laroute.route('project.budget_campaigns.create', {project: this.project.id}), this.newTickItem)
                    .then(response => {
                        if (response.data.success) {
                            vm.fetchTickList();
                            vm.newItemToBase();
                        } else {
                            vm.throwError('Error :(');
                        }
                    })
                    .catch(error => {

                        vm.throwError(_.values(error.response.data.errors));
                    });
                // resource.save(this.newTickItem).then(function (response) {
                //     response = response.body;
                //     if (response.success) {
                //         vm.fetchTickList();
                //         vm.newItemToBase();
                //     } else {
                //         this.throwError(response.error);
                //     }
                // });
            },
            editTickListItem: function () {
                // var resource = this.$resource('/visi/api/budget-campaigns{/id}');
                let vm = this;
                this.disableErrors();
//                if(this.editTickItem.id){

                axios.post(laroute.route('json.budget_campaigns.update', {budget_campaign: vm.editTickItem.id}), vm.editTickItem)
                    .then(response => {
                        if (response.data.success) {
                            vm.edit = false;
                            vm.fetchTickList();
                        } else {
                            vm.throwError('Error :{');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));

                    });

//                    resource.post(this.editTickItem).then(function (response) {
//                 this.$http.put('/visi/api/budget-campaigns/' + this.editTickItem.id, this.editTickItem).then(function (response) {
//                     response = response.body;
//                     if (response.success) {
//                         vm.edit = false;
//                         vm.fetchTickList();
//                     } else {
//                         this.throwError(response.error);
//                     }
//                 });

//                }
//                else {
//                    resource.save(this.newTickItem).then(function (response) {
//                        response = response.body;
//                        if (response.success) {
//                            vm.fetchTickList();
//                            vm.newItemToBase();
//                        } else {
//                            this.throwError(response.error);
//                        }
//                    });
//                }
            },
            makeShowTickList: function () {
                this.showTickList = true;
            },
            fetchTickList: function () {
                let vm = this;
                // var resource = this.$resource('/visi/api/budget-campaigns{/id}');

                this.disableErrors();
                axios.get(laroute.route('project.budget_campaigns', {project: this.project.id}))
                    .then(response => {
                        if (response.data.success) {
                            vm.tickList = response.data.data;
                        } else {
                            vm.throwError('Error :(');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));
                    });

                // resource.get({project_id: "{{$project->id}}"}).then(function (response) {
                //     response = response.body;
                //
                //     if (response.success) {
                //         vm.tickList = response.data;
                //     } else {
                //         this.throwError(response.error);
                //     }
                //
                // });
            }

        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/projects/ProjectBudgetList.vue